import { render, staticRenderFns } from "./LotsTabTable.vue?vue&type=template&id=79d2e92a"
import script from "./LotsTabTable.vue?vue&type=script&lang=js"
export * from "./LotsTabTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports